import { render, staticRenderFns } from "./TalentMatrixAxisFormulaSelect.vue?vue&type=template&id=4362dd28&scoped=true"
import script from "./TalentMatrixAxisFormulaSelect.vue?vue&type=script&lang=js"
export * from "./TalentMatrixAxisFormulaSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362dd28",
  null
  
)

export default component.exports